import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Monogram } from "../site/Logo";
import { Reveal } from "../site/Reveal";

const swatches = ["#2A0F2E", "#D61F69", "#F25A1F", "#0FA3A3", "#D4AF37", "#FAF7F2"];

export const Lifestyle = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-40, 80]);
  return (
    <section ref={ref} data-testid="lifestyle-section" className="relative overflow-hidden bg-cream-warm py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
        <div className="relative h-[460px] sm:h-[560px]">
          <motion.div style={{ y: y1 }} className="absolute left-0 top-0 h-[78%] w-[62%] overflow-hidden rounded-t-[999px] rounded-b-3xl shadow-2xl">
            <img src="/images/blazer.jpg" alt="Woman in a blush blazer" loading="lazy" className="h-full w-full object-cover" />
          </motion.div>
          <motion.div style={{ y: y2 }} className="absolute bottom-0 right-0 h-[55%] w-[50%] overflow-hidden rounded-3xl border-[6px] border-cream shadow-2xl">
            <img src="/images/jewelry-set.jpg" alt="Gold jewelry set" loading="lazy" className="h-full w-full object-cover" />
          </motion.div>
          <div className="absolute right-[8%] top-[6%]">
            <Monogram className="h-24 w-24 sm:h-28 sm:w-28 text-[11px] sm:text-[13px]" />
          </div>
        </div>
        <div>
          <Reveal><p className="eyebrow text-gold-deep">Our promise</p></Reveal>
          <Reveal delay={0.1}>
            <h2 data-testid="lifestyle-heading" className="mt-5 font-script text-6xl sm:text-7xl lg:text-8xl leading-[1.05] text-plum">
              More Than a Store… <span className="block dream-gradient pr-4">It's a Lifestyle.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-lg text-base sm:text-lg leading-relaxed text-plum/80">
              Luxe Dream Market brings together statement fashion, polished accessories, beautiful home pieces and gifts that feel special. Everyday luxury, without the fuss.
            </p>
          </Reveal>
          <Reveal delay={0.3} className="mt-10 flex items-center gap-3">
            {swatches.map((c, i) => (
              <motion.span key={c} whileHover={{ y: -6, scale: 1.1 }} className="h-10 w-10 sm:h-12 sm:w-12 rounded-full border border-plum/15 shadow-md" style={{ background: c }} transition={{ type: "spring", stiffness: 300 }} aria-hidden="true" data-i={i} />
            ))}
          </Reveal>
          <Reveal delay={0.4} className="mt-10">
            <Link to="/shop" data-testid="lifestyle-cta" className="btn-luxe">Explore the Collection</Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
